export enum SupportSlotAssignmentTypeEnum {
  CONSULTATION = 'CONSULTATION',
  ANALYSIS = 'ANALYSIS',
  GENERAL = 'GENERAL'
}